import * as watchers from './home-watchers'
import { fork } from 'redux-saga/effects'

export default [
  fork(watchers.watchHomeLoadPage),
  fork(watchers.watchHomeLoadPastEventGroups),
]



/** WEBPACK FOOTER **
 ** ./src/sagas/home/index.js
 **/